/**
 * BatchGeoMarkerMeasurePolylines manages the polylines.
 */
(function () {
  var BatchGeoMarkerMeasurePolylines = function () {
    this.polylines = {};
  };

  /**
   * Creates and returns a styled Google Maps Polyline instance with the given
   * path specifically meant for use with MarkerMeasure
   * @private
   * @param {array} path An array of google map lat,lng positions to create path
   * @return {object} Returns a Google Maps Polyline instance
   */
  var createPolyline = function (path, color) {
    var map = window.batchGeoGoogleMapsManager.getMap();
    return new google.maps.Polyline({
      map: map,
      path: path,
      strokeColor: color || "#4285F4",
      strokeOpacity: 0.8,
    });
  };

  /**
   * Saves the given polylines to the collection
   * @param {array} path An array of google map lat,lng positions to create path
   * @return {undefined}
   */
  BatchGeoMarkerMeasurePolylines.prototype.addPolyline = function (
    path,
    index,
    color,
  ) {
    this.polylines[index] = createPolyline(path, color);
  };

  /**
   * Updates a polyline class at a given index. Usually used to update the
   * lat/lng.
   * @param {number} index the index of the polyline to replace
   * @param {object} polyline A Google Maps Polyline class
   * @return {undefined}
   */
  BatchGeoMarkerMeasurePolylines.prototype.updatePolyline = function (
    index,
    polyline,
  ) {
    if (!(polyline instanceof google.maps.Polyline)) {
      return console.error(
        "Given argument is not a Google Maps Polyline instance",
      );
    }
    this.polylines[index] = polyline;
  };

  /**
   * Returns the Google Maps Polyline collection
   * @return {Array} Will return an array of the Google Maps Polyline collection
   */
  BatchGeoMarkerMeasurePolylines.prototype.getPolylines = function () {
    return this.polylines;
  };

  /**
   * Removes the polyline at a given index
   * @return {undefined}
   */
  BatchGeoMarkerMeasurePolylines.prototype.removePolyline = function (index) {
    this.polylines[index].setMap(null);

    delete this.polylines[index];
  };

  /**
   * Clears all polylines in the polyline collection
   * @return {undefined}
   */
  BatchGeoMarkerMeasurePolylines.prototype.clearPolylines = function () {
    Object.keys(this.polylines).forEach((key) => {
      this.polylines[key].setMap(null);
    });

    this.polylines = {};
  };

  window.BatchGeoMarkerMeasurePolylines = BatchGeoMarkerMeasurePolylines;
})();
